/**
 * Where the pointer last was over the stage (V0.54) — or null once it has left.
 *
 * Ctrl+V pastes onto the EMPTY map at the pointer, and a keyboard event carries no position, so
 * something has to remember the last one. `MapStage`'s pointer handling writes it and
 * `chrome.ts`'s keyboard reads it — the `dragOffset.ts` shape: one module-level value, no
 * React, because a `pointermove` must not become a render.
 */

let last: { x: number; y: number } | null = null;

export const setStagePointer = (p: { x: number; y: number } | null): void => {
  last = p;
};

export const stagePointer = (): { x: number; y: number } | null => last;
